import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { HelicoptersService } from "../helicopters/helicopters.service";
import { LocalStorageService } from "../shared/local-storage.service";
import { Helicopter } from "../shared/models/helicopter.model";
import { NextDueMaintenanceService } from "./next-due-maintenance.service";
import { UpdateNextDueMaintenanceDialogComponent } from "./update-next-due-maintenance-dialog/update-next-due-maintenance-dialog.component";
import { NextDueMaintenanceTableComponent } from "./next-due-maintenance-table/next-due-maintenance-table.component";
import { AppConfigType } from "../shared/models/appConfig.model";
import { forkJoin } from "rxjs";

@Component({
    selector: "app-next-due-maintenance",
    templateUrl: "./next-due-maintenance.component.html",
    styleUrls: ["./next-due-maintenance.component.scss"],
    standalone: false,
})
export class NextDueMaintenanceComponent implements OnInit {
    @ViewChild("table") table: NextDueMaintenanceTableComponent;
    public helicoptersArray: Helicopter[] = [];
    public chosenAircraft: Helicopter;

    public aircraftOptions: { name: string; value: number }[];
    public selectedAircraftOption: number;

    private _userSession;
    private _helicopterId: number;

    public organizationId: number;

    public showTolerance = false;
    public showFlightNumber = false;
    public showEnginePowerCheck = false;
    public showReference = false;
    public hasEnginePowerCheck = false;
    public showHookHoist = false;

    public isCamo = false;

    public helicopterData: any;
    public helicopterWarnings: any;
    public helicopterHooks: any;
    public helicopterHoists: any;

    constructor(
        private _route: ActivatedRoute,
        private _helicoptersService: HelicoptersService,
        private _localStorageService: LocalStorageService,
        private _router: Router,
        private _dialog: MatDialog,
        private _nextDueMaintenanceService: NextDueMaintenanceService,
    ) {
        this._userSession = this._localStorageService.getUserLocalStorageObject();
    }

    ngOnInit(): void {
        // Get organization id to check for slagboom for "out of phase" text
        this.organizationId = this._userSession.organizationId;
        if (this._userSession.htlAccountTypes.length > 0) {
            switch (this._userSession.htlAccountTypes[0].id) {
                case 1:
                    this.isCamo = true;
                    break;
                case 2:
                    this.isCamo = true;
                    break;
            }
        }

        if (JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.shortFrequencyWarnings).value).tolerance) {
            this.showTolerance = true;
        }

        if (JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.flightNumber).enabled)) {
            this.showFlightNumber = true;
        }

        if (JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.enginePowerCheck).value).automatic) {
            this.showEnginePowerCheck = true;
        }

        if (JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.shortFrequencyWarnings).value).reference) {
            this.showReference = true;
        }

        this._helicoptersService.getHelicopters(this._userSession.organizationId).subscribe((helicopters) => {
            this.helicoptersArray = helicopters;
            this.aircraftOptions = this.helicoptersArray.map((h) => {
                return { name: h.registrationMark, value: h.id };
            });
            if (this.helicoptersArray.length > 0) {
                this.selectedAircraftOption = this.helicoptersArray[0].id;
                this.chooseAircraft(this.helicoptersArray[0].id);
            }
        });
        this._nextDueMaintenanceService.$currentHelicopterId.subscribe((result) => {
            this._helicopterId = result;
        });
    }

    openUpdateShortItemDialog() {
        const dialogRef = this._dialog.open(UpdateNextDueMaintenanceDialogComponent, {
            disableClose: true,
            width: "50%",
            data: {
                helicopterId: this._helicopterId,
                shortItemId: this.table.selectedStlId,
                showTolerance: this.showTolerance,
                showFlightNumber: this.showFlightNumber,
                registrationMark: this.chosenAircraft.registrationMark,
                disableEnginePowerCheck: this.hasEnginePowerCheck,
                showReference: this.showReference,
                showEnginePowerCheck: this.showEnginePowerCheck,
                hookHoist: this.showHookHoist,
                helicopterData: this.helicopterData,
                hooks: this.helicopterHooks,
                hoists: this.helicopterHoists,
            },
        });

        dialogRef.afterClosed().subscribe(() => {
            if (this.showHookHoist) {
                this.table.fetchHookHoistData();
            } else {
                this.table.fetchShortTermData();
            }
        });
    }

    chooseAircraft(helicopterId: number) {
        const helicopter = this.helicoptersArray.find((h) => h.id === helicopterId);
        this.showHookHoist = false;
        this.chosenAircraft = helicopter;
        this._helicopterId = helicopter.id;
        forkJoin(
            this._nextDueMaintenanceService.getAircraftData(helicopter.id),
            this._nextDueMaintenanceService.getHelicopterWarnings(helicopter.id),
            this._nextDueMaintenanceService.getHooks(helicopter.id),
            this._nextDueMaintenanceService.getHoists(helicopter.id),
        ).subscribe((res) => {
            this.helicopterData = res[0];
            this.helicopterWarnings = res[1];
            this.helicopterHooks = res[2];
            this.helicopterHoists = res[3];
        });
    }

    onDataLoaded(data: any) {
        if (data && data.length > 0) {
            this.hasEnginePowerCheck = data.some((item) => item?.isEnginePowerCheck && item?.status !== 2);
        } else {
            this.hasEnginePowerCheck = false;
        }
    }

    onTabChange(index: number) {
        this.showHookHoist = index === 1;
    }
}
